/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Invoice_Buyer_ToggleInputs */

const vi_order_form_invoice_buyer_toggle = /** @type {(inputs: Order_Form_Invoice_Buyer_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất hóa đơn điện tử cho đơn này`)
};

/**

* @param {Order_Form_Invoice_Buyer_ToggleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_invoice_buyer_toggle = /** @type {((inputs?: Order_Form_Invoice_Buyer_ToggleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Invoice_Buyer_ToggleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_invoice_buyer_toggle(inputs)
});